import { mString } from 'lib/helpers/utility';

export const cardFields = ({ amount, buttonText, scope = '', submitTarget }) => ({
  cardholderName: {
    target: `${scope}.card-holder-name`,
    errorTarget: `${scope}.card-holder-name-error`,
    placeholder: 'Cardholder name'
  },
  cardNumber: {
    target: `${scope}.card-number`,
    errorTarget: `${scope}.card-number-error`,
    placeholder: '•••• •••• •••• ••••'
  },
  cvv: {
    wrapperTarget: `${scope}.card-cvv-wrapper`,
    target: `${scope}.card-cvv`,
    errorTarget: `${scope}.card-cvv-error`,
    placeholder: 'CVV'
  },
  expiryDate: {
    target: `${scope}.card-expiry`,
    errorTarget: `${scope}.card-expiry-error`,
    placeholder: 'MM/YY'
  },
  submit: {
    target: submitTarget || '.payroc-card-submit-button',
    value: buttonText ? buttonText : amount ? `Pay ${mString(amount)}` : 'Pay now'
  }
});

export const getCardWrapperMap = (scope = '') => ({
  cardNumber: `${scope}.card-number-wrapper`,
  cardholderName: `${scope}.card-holder-name-wrapper`,
  expiryDate: `${scope}.card-expiry-wrapper`,
  cvv: `${scope}.card-cvv-wrapper`
});

export const achFields = ({ amount, buttonText, scope = '', submitTarget }) => ({
  nameOnAccount: {
    target: `${scope}.ach-account-holder`,
    errorTarget: `${scope}.ach-account-holder-error`,
    placeholder: 'Account holder name'
  },
  accountType: {
    target: `${scope}.ach-account-type`,
    errorTarget: `${scope}.ach-account-type-error`
  },
  achAccountNumber: {
    target: `${scope}.ach-account-number`,
    errorTarget: `${scope}.ach-account-number-error`,
    placeholder: 'Account number'
  },
  routingNumber: {
    target: `${scope}.ach-routing-number`,
    errorTarget: `${scope}.ach-routing-number-error`,
    placeholder: 'Routing number'
  },
  submit: {
    target: submitTarget || '.payroc-ach-submit-button',
    value: buttonText ? buttonText : amount ? `Pay ${mString(amount)}` : 'Pay now'
  }
});

export const getAchWrapperMap = (scope = '') => ({
  nameOnAccount: `${scope}.ach-account-holder-wrapper`,
  accountType: `${scope}.ach-account-type-wrapper`,
  achAccountNumber: `${scope}.ach-account-number-wrapper`,
  routingNumber: `${scope}.ach-routing-number-wrapper`
});
